import React, { FC } from 'react';
import { useTranslation } from '@jupiter-app/plugin-i18n';
import redArrow from '@/assets/imgs/default/red_arrow.svg';

import cx from 'classnames';
import { useHistory } from 'react-router';
interface LearnMoreProps {
  /* @deprecated use `onClick` instead */
  onClickLearnMore?: Function;
  onClick?: (event: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => void;
  fontSize?: number;
  classNames?: string;
  textKey?: string;
  href?: string;
  anal?: (...args: unknown[]) => unknown;
}

const LearnMore: FC<LearnMoreProps> = props => {
  const { onClickLearnMore, onClick, classNames, textKey, anal } = props;
  let href = props.href;
  const history = useHistory();
  const { t } = useTranslation();
  const onClickAction = onClick ?? onClickLearnMore;
  if (!onClickAction && !href) {
    throw new Error(
      'LearnMore component needs either onClick, onClickLearnMore, or href prop',
    );
  }
  const handleOnClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    anal?.();
    if (onClickAction) {
      event.preventDefault();
      onClickAction(event);
    } else {
      href = href!;
      if (event.ctrlKey || event.shiftKey || event.altKey || event.metaKey) {
        return;
      }

      event.preventDefault();
      // See NOTE[basename-is-weird]
      const basename: '/university' = history
        .createHref(new URL('https://tiktok.com'))
        .slice(0, -1) as '/university';
      const hrefWithStrippedBasename = href!.replace(basename, '');
      history.push(hrefWithStrippedBasename);

      // @ts-expect-error: I checked our stats in Tea and all our users can use `canParse`
      const url = URL.canParse(href, location.origin)
        ? new URL(href, location.origin)
        : undefined;
      if (url?.hash) {
        window.requestIdleCallback(() => {
          const target = document.querySelector(url.hash);
          target?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        });
      }
    }
  };
  return (
    <a
      className={cx(
        'flex flex-no-wrap items-center cursor-pointer text-brand-normal text-p3-regular',
        classNames,
      )}
      href={href}
      onClick={(...args) => handleOnClick(...args)}>
      <span className="mr-8 font-semibold">
        {textKey ? t(textKey) : t('academy_homepage_grow_view_more')}
      </span>
      <img src={redArrow} alt={'learn more arrow'} />
    </a>
  );
};

export default LearnMore;
